var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFacebookSocial = function SvgFacebookSocial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.853.093 5.576 0c-1.83 0-3.32 1.47-3.346 3.299v2.137H.14a.14.14 0 0 0-.14.14V8.27a.232.232 0 0 0 .14.14h2.09v6.737c0 .093.093.139.186.139h2.742a.14.14 0 0 0 .139-.14V8.41h2.09c.094 0 .14-.046.187-.14l.325-2.648a.186.186 0 0 0-.046-.14H5.297V4.136a1.626 1.626 0 0 1 .279-1.022.836.836 0 0 1 .65-.279h1.58c.093 0 .186-.046.186-.139V.279a.14.14 0 0 0-.14-.186Z",
    fill: "#525252"
  })));
};

export default SvgFacebookSocial;